import httpClient from '../httpClient';
import { DesktopAppDownloads } from 'models/DesktopApp';

function getDownloads() {
  return httpClient.get<DesktopAppDownloads>('desktop/application/downloads');
}

export default {
  getDownloads,
};
